module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/kodak-e86bfe118ab858a86576119ee43b8ad6.png";